import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const canStartRescuePanelSplit = {
  name: "canStartRescuePanelSplit" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    canStartWithDefaultRescuePanel: z.boolean(),
    canStartWithSpotlight: z.boolean(),
  }),
};
